import { BreadcrumbLink, HStack, Stack, VStack } from "@chakra-ui/react";
import * as React from "react";
import { LuClock4 } from "react-icons/lu";
import { useParams } from "react-router-dom";

import { getAudience } from "../api/audience";
import {
  BreadcrumbCurrentLink,
  BreadcrumbRoot,
} from "../components/breadcrumb";
import { EmptyState } from "../components/empty-state";
import IconCircle from "../components/icon-circle";
import Link from "../components/link";
import Page from "../components/page";
import PageBody from "../components/page-body";
import { useLoading, useWorkspaceURL } from "../hooks";
import { Audience } from "../types/audience";

export default function AudiencePage() {
  const { workspace, id } = useParams();
  const workspaceURL = useWorkspaceURL();
  const [isLoading, wrapLoading] = useLoading(true);
  const [audience, setAudience] = React.useState<Audience>(null);
  const loadAudience = React.useCallback(async () => {
    await wrapLoading(async () => {
      setAudience(await getAudience(workspace, Number(id)));
    });
  }, [id, workspace, wrapLoading]);
  React.useEffect(() => {
    loadAudience();
  }, [loadAudience]);

  return (
    <Page loading={isLoading}>
      {audience && (
        <PageBody>
          <Stack align="top" flex="1" gap="0">
            <BreadcrumbRoot>
              <BreadcrumbLink asChild>
                <Link to={workspaceURL("audiences")} variant="plain">
                  Audiences
                </Link>
              </BreadcrumbLink>
              <BreadcrumbCurrentLink>{audience.name}</BreadcrumbCurrentLink>
            </BreadcrumbRoot>
            <HStack flex="1" alignItems="center">
              <VStack flex="1">
                <EmptyState
                  icon={<IconCircle Icon={LuClock4} size="md" variant="flat" />}
                  title="Audience Ready"
                  description="Your audience has been created and will start ingesting data within the next 24 hours."
                  w="sm"
                />
              </VStack>
            </HStack>
          </Stack>
        </PageBody>
      )}
    </Page>
  );
}
